<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Stocks
        <span class="separator" />
      </h1>
    </b-col>
    <ListeStatsStocks />
  </div>
</template>

<script>
import ListeStatsStocks from "@/components/stats/ListeStatsStocks.vue";

export default {
  name: "StatsStocks",
  components: {
    ListeStatsStocks,
  },
};
</script>

<style lang="scss" scoped>
</style>
